import React, {
	useEffect, useMemo, useState,
} from 'react';
import classNames from 'classnames';
import { ContentServiceJobStatus } from '../../stores/reducers/generate-content';
import Icon, { COLORS, ICONS } from '../../components/general-components/icon';

export default function useProcessingToaster(
	jobStatus?: ContentServiceJobStatus,
	generatedContentId?: number,
	isMediaItem?: boolean, // the media item editing container is slightly different
) {
	const [isProcessing, setIsProcessing] = useState(false);
	const [fauxProcessing, setFauxProcessing] = useState(0);

	// may the variable name "timmy" bring you good fortune
	const timmy = React.useRef<NodeJS.Timeout>();

	useEffect(() => {
		setIsProcessing(jobStatus === ContentServiceJobStatus.processing);
	}, [jobStatus]);

	const debounceProcessingToast = () => {
		clearTimeout(timmy.current);
		setFauxProcessing(generatedContentId ?? 0);
		timmy.current = setTimeout(() => {
			setFauxProcessing(0);
		}, 4000);
	};

	const processing = useMemo(
		() => isProcessing || (fauxProcessing === generatedContentId),
		[isProcessing, fauxProcessing, generatedContentId],
	);

	const UpdatingToaster = useMemo(
		() => <div
			id="slide-down"
			className={classNames(
				'content-generator-processing',
				{ processing, 'for-media': isMediaItem },
			)}
		>
			<Icon name={ICONS.REFRESH} size={16} color={COLORS.PALE_GREEN}/>
			<div className="content-generator-processing-label">
				Updating...
			</div>
		</div>,
		[processing],
	);

	return {
		UpdatingToaster,
		debounceProcessingToast,
	};
}
